import { useMediaQuery } from "@material-ui/core";

export default function useMobile() {
  const matches = useMediaQuery("(max-device-width:1023px), (orientation: portrait)");

  return matches;
}
